module.exports = __webpack_public_path__ + "assets/img/SportsFever360.74bdcac8.jpg";